@if ((isProcessing$ | async) === true) {
  <div
    class="tw-absolute tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-bg-white/60"
  >
    <div
      class="tw-inline-block tw-size-14 tw-animate-spin tw-rounded-full tw-border-2 tw-border-current tw-border-t-transparent tw-text-primary"
      role="status"
      aria-label="loading"
    ></div>
  </div>
}
<h3 class="tw-font-bold tw-text-eerie-black">{{ title }}</h3>
@if (description) {
  <p class="tw-mt-5">{{ description }}</p>
}
<ul class="tw-mt-5 tw-text-sm tw-text-battleship-gray">
  @for (label of labels.conditions; track label) {
    <li>{{ label }}</li>
  }
</ul>
@if (form.controls.document.touched && form.controls.document.errors) {
  <div class="tw-mt-2.5 tw-flex tw-items-center tw-text-tomato">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      class="tw-mr-2.5 tw-size-6 tw-fill-tomato"
    >
      <path
        d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
      />
    </svg>
    {{ fileError }}
  </div>
}
@if (hasApiError$ | async) {
  <div class="tw-mt-2.5 tw-flex tw-items-center tw-text-tomato">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 320 512"
      class="tw-mr-2.5 tw-size-6 tw-fill-tomato"
    >
      <path
        d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
      />
    </svg>
    {{ labels.apiError }}
  </div>
}
@if ((preview$ | async) === undefined) {
  <div
    class="tw-mt-5 tw-rounded-sm tw-border-2 tw-border-dashed tw-border-platinum tw-px-5 tw-py-15 tw-text-center sm:tw-p-22.5"
    [class.tw-border-tomato]="form.controls.document.touched && form.controls.document.errors"
    iaDragAndDrop
    (fileDropped)="onFileDropped($event)"
  >
    <div>{{ labels.uploadBox.label }}</div>
    <div
      class="before:tw-border-t-alto after:tw-border-t-alto tw-mt-10 tw-flex tw-items-center tw-space-x-3 tw-border-geyser tw-text-sm tw-text-battleship-gray before:tw-block before:tw-flex-1 before:tw-border-t after:tw-block after:tw-flex-1 after:tw-border-t"
    >
      OU
    </div>
    <label
      for="document-upload"
      class="tw-mt-10 tw-inline-flex tw-h-9 tw-cursor-pointer tw-items-center tw-rounded-full tw-bg-button-primary tw-px-6.5 tw-font-sans tw-text-base tw-font-semibold tw-text-button-primary-text tw-shadow-none hover:tw-bg-button-primary-hover"
    >
      {{ labels.uploadBox.button }}
    </label>
    <input
      type="file"
      id="document-upload"
      data-test-id="document-upload"
      class="tw-hidden"
      #fileInput
      (change)="fileBrowseHandler($event)"
    />
  </div>
}
@if (preview$ | async; as preview) {
  <div
    class="tw-mt-5 tw-h-86 tw-rounded-sm tw-border-2 tw-border-dashed tw-border-platinum tw-text-center"
  >
    <ng-container>
      @if (preview.type.toLowerCase() === DocumentMimeType.PDF) {
        <iframe
          [src]="preview.path || '' | safe: 'resourceUrl'"
          class="tw-block tw-size-full"
          title=""
        ></iframe>
      }
      @if (
        preview.type.toLowerCase() === DocumentMimeType.JPG ||
        preview.type.toLowerCase() === DocumentMimeType.JPEG ||
        preview.type.toLowerCase() === DocumentMimeType.PNG
      ) {
        <img [src]="preview.path || '' | safe: 'url'" class="tw-block tw-size-full" alt="" />
      }
      @if (
        preview.type.toLowerCase() === DocumentMimeType.DOC ||
        preview.type.toLowerCase() === DocumentMimeType.DOCX
      ) {
        <div class="tw-flex tw-size-full tw-items-center tw-justify-center">
          <div class="tw-flex tw-flex-col tw-items-center tw-space-y-5">
            <ia-icons name="memo" class="tw-flex tw-size-23" />
            <a
              iaButton
              variant="primary"
              [href]="preview.path || '' | safe: 'url'"
              target="_blank"
              role="button"
              download
            >
              {{ labels.download }}
            </a>
          </div>
        </div>
      }
    </ng-container>
  </div>
}
@if (documents$ | async; as documents) {
  @if (documents.length) {
    <div class="tw-mt-5 tw-flex tw-space-x-2">
      @for (file of documents; track file; let index = $index) {
        <div class="tw-flex tw-w-27.5 tw-flex-col">
          <span
            class="tw-h-6 tw-w-full tw-overflow-hidden tw-overflow-ellipsis tw-whitespace-nowrap"
          >
            {{ file.filename }}.{{ file.type }}
          </span>
          <button
            class="tw-relative tw-flex tw-h-22.5 tw-w-27.5 tw-cursor-pointer tw-flex-col tw-items-center tw-border tw-border-geyser tw-p-2.5 before:tw-absolute before:tw-top-full before:tw-z-20 before:tw-size-8 before:tw--translate-y-1/2 before:tw-bg-no-repeat after:tw-absolute after:tw-inset-0 after:tw-z-10 hover:after:tw-bg-black/20"
            [ngClass]="{
              'after:tw-bg-black/20': (preview$ | async)?.referenceId === file.referenceId,
            }"
            (click)="onSelectDocument(file)"
            id="btn-select-doc"
            data-test-id="btn-select-doc"
          >
            <ia-icons name="memo" class="tw-flex tw-size-8" />
            <span>{{ labels.file }} {{ index + 1 }}</span>
          </button>
          <button
            type="button"
            (click)="onRemoveDocument(file)"
            class="tw-mt-4 tw-text-center tw-text-emerald"
            id="btn-remove-doc"
            data-test-id="btn-remove-doc"
          >
            {{ labels.delete }}
          </button>
        </div>
      }
      @if ((preview$ | async) && documents.length < maxNumberOfDocuments) {
        <button
          class="tw-mt-6 tw-flex tw-h-22.5 tw-w-27.5 tw-cursor-pointer tw-flex-col tw-items-center tw-border tw-border-geyser tw-p-2.5 tw-shadow-inner"
          (click)="onNewDocument()"
          id="btn-new-doc"
          data-test-id="btn-new-doc"
        >
          <img
            alt="picto-plus.PNG"
            src="/content/dam/app/ia-succession/picto-plus.png"
            class="tw-w-6.5"
          />
          <span class="tw-text-center">{{ labels.add }}</span>
        </button>
      }
    </div>
  }
  @if (documents.length || hasDocuments) {
    <div class="tw-mt-5 tw-text-right">
      <button
        iaButton
        type="button"
        variant="primary"
        (click)="onSaveDocuments()"
        id="btn-save-doc"
        data-test-id="btn-save-doc"
      >
        {{ labels.submit }}
      </button>
    </div>
  }
}
